import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface NavigationGuardContextType {
	hasUnsavedChanges: boolean;
	setHasUnsavedChanges: (value: boolean) => void;
	confirmNavigation: () => boolean;
}

const NavigationGuardContext = createContext<NavigationGuardContextType | null>(null);

export function NavigationGuardProvider({ children }: { children: ReactNode }) {
	const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

	const confirmNavigation = useCallback(() => {
		if (!hasUnsavedChanges) return true;

		return window.confirm(
			"You have unsaved changes. Are you sure you want to leave this page? Your changes will be lost."
		);
	}, [hasUnsavedChanges]);

	return (
		<NavigationGuardContext.Provider value={{ hasUnsavedChanges, setHasUnsavedChanges, confirmNavigation }}>
			{children}
		</NavigationGuardContext.Provider>
	);
}

export function useNavigationGuard() {
	const context = useContext(NavigationGuardContext);
	if (!context) {
		throw new Error("useNavigationGuard must be used within a NavigationGuardProvider");
	}
	return context;
}
